import React from "react";
import { type WeddingLanguage, weddingContent } from "./content";
import chapterPhoto01 from "../../assets/img/chapters/chapter-photo-01.jpg";
import chapterPhoto02 from "../../assets/img/chapters/chapter-photo-02.jpg";
import chapterPhoto03 from "../../assets/img/chapters/chapter-photo-03.jpg";
import chapterPhoto04 from "../../assets/img/chapters/chapter-photo-04.jpg";
import chapterPhoto05 from "../../assets/img/chapters/chapter-photo-05.jpg";
import chapterPhoto06 from "../../assets/img/chapters/chapter-photo-06.jpg";
import chapterPhoto07 from "../../assets/img/chapters/chapter-photo-07.jpg";

interface ChaptersProps {
  language: WeddingLanguage;
}

const chapterImages = [chapterPhoto01, chapterPhoto04, chapterPhoto07];
const chapterCollages = [
  [
    chapterPhoto01,
    chapterPhoto02,
    chapterPhoto03,
    chapterPhoto04,
    chapterPhoto05,
    chapterPhoto06,
  ],
  [
    chapterPhoto02,
    chapterPhoto03,
    chapterPhoto04,
    chapterPhoto05,
    chapterPhoto06,
    chapterPhoto07,
  ],
  [
    chapterPhoto07,
    chapterPhoto06,
    chapterPhoto05,
    chapterPhoto04,
    chapterPhoto03,
    chapterPhoto01,
  ],
];

export function Chapters({ language }: ChaptersProps) {
  const chapters = weddingContent[language].chapters;
  const heading = language === "vi" ? "Những Chương Chuyện Mình" : "Our Chapters";

  return (
    <section className="wedding-chapters" aria-label="Wedding chapters">
      <div className="wedding-chapters__header">
        <div className="wedding-header">
          <h2 className="wedding-title">{heading}</h2>
          <div className="wedding-divider" />
        </div>
      </div>

      {chapters.map((chapter, index) => (
        <article
          className={`wedding-chapter wedding-chapter--${index + 1}`}
          key={chapter.title}
        >
          <div
            className="wedding-chapter__image"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(10, 8, 6, 0.2) 0%, rgba(10, 8, 6, 0.32) 48%, rgba(10, 8, 6, 0.56) 100%), url(${chapterImages[index]})`,
            }}
          >
            <div className="wedding-chapter__heading">
              <p className="wedding-chapter__label">{chapter.label}</p>
              <h2 className="wedding-chapter__title">{chapter.title}</h2>
              <p className="wedding-chapter__subtitle">{chapter.subtitle}</p>
            </div>
          </div>

          <div
            className={`wedding-chapter__panel ${
              index % 2 === 1 ? "wedding-chapter__panel--reverse" : ""
            }`}
          >
            <div className="wedding-chapter__collage" aria-hidden="true">
              {chapterCollages[index].map((image, imageIndex) => (
                <div
                  className={`wedding-chapter__frame wedding-chapter__frame--${
                    imageIndex + 1
                  }`}
                  key={image}
                >
                  <img src={image} alt="" />
                </div>
              ))}
            </div>

            <div className="wedding-chapter__copy">
              {chapter.description.map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex}>{paragraph}</p>
              ))}
            </div>
          </div>
        </article>
      ))}
    </section>
  );
}
